import React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import propTypes from 'prop-types';
import ConfirmActionModal from '../../Modal/components/ConfirmActionModal';
import DataService from '../../common/services/dataService';
import { display, fontWeight, textTransform } from '@mui/system';

const PREFIX = 'LinksTable';

const classes = {
  tableBluebar: `${PREFIX}-tableBluebar`,
  columnTitle: `${PREFIX}-columnTitle`,
  actionButton: `${PREFIX}-actionButton`
};

const StyledPaper = styled(Paper)(() => ({
  [`& .${classes.tableBluebar}`]: {
    background: 'rgba(239, 239, 247, 0.7)',
    borderBottom: '2px solid #dcdef1',
    borderTop: '1px solid #dcdef1',
  },

  [`& .${classes.columnTitle}`]: {
    fontWeight: 700,
    padding: 12,
    fontSize: '0.83125rem',
    textTransform: 'uppercase',
    color: 'rgb(59, 62, 102)',
  },

  [`& .${classes.actionButton}`]: {
    color: '#5383ff',
    border: '1px solid rgba(83, 131, 255, 0.5)',
    borderRadius: '0.5rem',
    fontSize: 13,
    fontWeight: 400,
    textTransform: 'none',
    whiteSpace: 'nowrap'
  }
}));

function numberToWord(number) {
  switch (number) {
    case 1:
      return 'first';
    case 2:
      return 'second';
    case 3:
      return 'third';
    case 4:
      return 'fourth';
    case 5:
      return 'fifth';
    case 6:
      return 'sixth';
    case 7:
      return 'seventh';
    case 8:
      return 'eigth';
    case 9:
      return 'ninth';
    case 10:
      return 'tenth';
    case 11:
      return 'eleventh';
    case 12:
      return 'twelfth';
    case 13:
      return 'thirteenth';
    case 14:
      return 'fourteenth';
    case 15:
      return 'fifteenth';
    default:
      return 'first';
  }
}

function LinksTable({
  
  newStudySuccessMessage,
  superUser
}) {


  console.log('LinksTable props:', { newStudySuccessMessage, superUser });

  if (!newStudySuccessMessage) return null;

  return (
    <StyledPaper variant='outlined' style={{ width: '100%' }}>
      <TableContainer>
        <Table className={classes.table} aria-label='simple table'>
          <TableHead className={classes.tableBluebar}>
            <TableRow>
              <TableCell
                style={{ paddingLeft: 20 }}
                className={classes.columnTitle}
                align='left'
              >
                Study Previews
              </TableCell>
              <TableCell className={classes.columnTitle} align='center' />
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow key='testStudy'>
              <TableCell component='th' scope='row'>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div>
                    <b style={{ color: '#3b3e66', display: 'block' }}>
                      Take a test study
                    </b>
                    <span
                      style={{ color: 'rgba(7,9,25,.5)', display: 'block' }}
                    >
                      This link will allow you to take the study but your results
                      will not be counted
                    </span>
                  </div>
                </div>
              </TableCell>
              <TableCell align='center' style={{display: "flex", justifyContent: "space-around"}}>
                <Button style={{height: "30.35px", marginTop: "0.5rem"}}
                  size='small'
                  variant='outlined'
                  className={classes.actionButton}

                  href={newStudySuccessMessage.start_url_test.replace('&participant=', '')}
                  target='_blank'
                >
                  Test study
                </Button>
                
                {superUser ? (
                  <ConfirmActionModal
                className={'AutomateBtn'}
                    openButtonText={'Automate'}
                    title='Automate Study Run Through'
                    mainText={'Confirm trigger of the study run-through test?'}
                    action={() => DataService.handleAutomateStudy(newStudySuccessMessage?.study_id)
                    } 
                />
                  ) : (
                    <Tooltip title="Only Admin can automate this study">
                      <Button variant='contained' disabled style={{color: '#999',
                      backgroundColor: '#f5f5f5',
                      border: '1px solid #ccc',
                      borderRadius: '0.5rem',
                      fontSize: 13,
                      fontWeight: 400,
                      textTransform: 'none',
                      whiteSpace: 'nowrap',
                      marginTop: '0.5rem',
                      height: '30.35px',
                      width: '79.43px',
                      boxShadow: 'none',}} >
                        Automate
                      </Button>
                    </Tooltip>
                    
                  )}
                
              </TableCell>
            </TableRow>
            <TableRow key='realStudy'>
              <TableCell component='th' scope='row'>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div>
                    <b style={{ color: '#3b3e66', display: 'block' }}>
                        Take a real study
                    </b>
                    <span
                      style={{ color: 'rgba(7,9,25,.5)', display: 'block' }}
                    >
                      This link will allow you to take the study and your data
                      will be included in the final results
                    </span>
                  </div>
                </div>
              </TableCell>
              <TableCell align='center'>
                <Button
                  size='small'
                  variant='outlined'
                  className={classes.actionButton}

                  href={newStudySuccessMessage.start_url.replace('&participant=', '')}
                  target='_blank'
                >
                  Take study
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
          {newStudySuccessMessage.incontext_urls.length > 0 ? (
            <>
              <TableHead className={classes.tableBluebar}>
                <TableRow>
                  <TableCell
                    style={{ paddingLeft: 24 }}
                    className={classes.columnTitle}
                    align='left'
                  >
                    Page Previews
                  </TableCell>
                  <TableCell className={classes.columnTitle} align='center' />
                </TableRow>
              </TableHead>
              <TableBody>
                {newStudySuccessMessage.incontext_urls.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell component='th' scope='row'>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div>
                          <b style={{ color: '#3b3e66', display: 'block' }}>
                            View Page {index + 1}
                          </b>
                          <span
                            style={{ color: 'rgba(7,9,25,.5)', display: 'block' }}
                          >
                            This will be the {numberToWord(index + 1)} test page your respondents will see. Please check everything is just how you want it
                          </span>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell align='center'>
                      <Button
                        size='small'
                        variant='outlined'
                        className={classes.actionButton}
                        href={row.step_url}
                        target='_blank'
                      >
                        View page
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </>
          ) : null}
        </Table>
      </TableContainer>
    </StyledPaper>
  );
}

LinksTable.propTypes = {
  newStudySuccessMessage: propTypes.object,
};

const mapStateToProps = (state) => {
  // console.log('Full Redux state:', state);
  return {
    newStudySuccessMessage: state.studyData.newStudySuccessMessage,
    superUser: state.userData.userData.super_user,
    
  };
  
};

export default withRouter(
  connect(
    mapStateToProps,
  )(LinksTable)
);
